import './step-navigator.scss';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const StepNavigator = ({
  steps,
  currentStep,
  completedStepIds,
  onStepClick,
  stepReviewStatuses
}) => {
  const isResubmission = stepReviewStatuses && Object.keys(stepReviewStatuses).length > 0;

  return (
    <div className="step-navigator">
      <ul className="step-navigator__list">
        {steps.map((step, index) => {
          const reviewStatus = stepReviewStatuses?.[step.id]?.status || null;
          const isComplete = completedStepIds.includes(step.id);
          const isCurrent = currentStep === step.id && !isComplete && !reviewStatus;
          const isLast = index === steps.length - 1;
          const isClickable = onStepClick && (isResubmission || isComplete || isCurrent);

          return (
            <React.Fragment key={step.id}>
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */}
              <li
                className={classNames('step-navigator__item', {
                  'step-navigator__item--current': isCurrent,
                  'step-navigator__item--complete': isComplete && !reviewStatus,
                  'step-navigator__item--approved': reviewStatus === 'APPROVED',
                  'step-navigator__item--declined': reviewStatus === 'DECLINED',
                  'step-navigator__item--submitted': reviewStatus === 'SUBMITTED',
                  'step-navigator__item--pending': reviewStatus === 'PENDING',
                  'step-navigator__item--clickable': isClickable
                })}
                onClick={() => isClickable && onStepClick(step.id)}>
                <div className="step-navigator__circle">
                  {isComplete || reviewStatus ? (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2 7L5.5 10.5L12 3.5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <span>{step.id}</span>
                  )}
                </div>
                <span className="step-navigator__label">{step.label}</span>
                {!reviewStatus && isCurrent && (
                  <span className="step-navigator__badge">CURRENT</span>
                )}
                {!reviewStatus && isComplete && (
                  <span className="step-navigator__badge step-navigator__badge--complete">
                    COMPLETE
                  </span>
                )}
                {reviewStatus === 'APPROVED' && (
                  <span className="step-navigator__badge step-navigator__badge--approved">
                    APPROVED
                  </span>
                )}
                {reviewStatus === 'DECLINED' && (
                  <span className="step-navigator__badge step-navigator__badge--declined">
                    DECLINED
                  </span>
                )}
                {reviewStatus === 'SUBMITTED' && (
                  <span className="step-navigator__badge step-navigator__badge--submitted">
                    SUBMITTED
                  </span>
                )}
                {reviewStatus === 'PENDING' && (
                  <span className="step-navigator__badge step-navigator__badge--pending">
                    PENDING
                  </span>
                )}
              </li>

              {!isLast && (
                <li className="step-navigator__connector" aria-hidden="true">
                  <div className="step-navigator__connector-line" />
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

StepNavigator.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
  completedStepIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onStepClick: PropTypes.func,
  stepReviewStatuses: PropTypes.object
};

export { StepNavigator };
